import { render, staticRenderFns } from "./PublicPage.vue?vue&type=template&id=51ab7243&"
import script from "./PublicPage.vue?vue&type=script&lang=js&"
export * from "./PublicPage.vue?vue&type=script&lang=js&"
import style0 from "./PublicPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports